import PropTypes from "prop-types";
import { getImage } from "utils";
import { useContent } from "hooks/discovery";
import Ellipsis from "components/Ellipsis";

const ContentRow = ({
  docName,
  legends,
  location,
  docRef,
  text,
  docView,
  reversedColumnWidths,
}) => {
  const content = useContent(text, true);

  return (
    <div data-testid="content-body-row" className="content__body__row">
      {!docView && (
        <span
          style={{ width: reversedColumnWidths[4] }}
          className="content__body__row__document"
        >
          <img src={getImage(docName)} alt="doc-img" />
          <span title={docName}>{docName}</span>
        </span>
      )}
      <span
        style={{ width: reversedColumnWidths[3] }}
        className="content__body__row__terms"
      >
        {legends.map((legend) => (
          <Ellipsis key={legend} text={legend} />
        ))}
      </span>
      <span
        style={{ width: reversedColumnWidths[2] }}
        className="content__body__row__location"
      >
        {location}
      </span>
      <span
        style={{ width: reversedColumnWidths[1] }}
        className="content__body__row__ref"
      >
        {docRef}
      </span>
      <span
        style={{ width: reversedColumnWidths[0] }}
        className="content__body__row__content"
      >
        {content}
      </span>
    </div>
  );
};

ContentRow.propTypes = {
  docName: PropTypes.string.isRequired,
  legends: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.string.isRequired,
  docRef: PropTypes.string,
  text: PropTypes.string.isRequired,
  docView: PropTypes.bool.isRequired,
  reversedColumnWidths: PropTypes.arrayOf(PropTypes.number),
};

export default ContentRow;
